const de = {
  title: 'Entitlementgruppen',
  createRole: 'Rolle erstellen',
  tableHeader: {
    entitlements: 'Entitlements',
    entitlementGroup: 'Entitlementgruppe',
    roles: 'Rollen'
  },
  model: {
    name: 'Rollenname',
    entitlementGroups: 'EntitlementGruppen',
    permissions: 'Berechtigungen'
  },
  form: {
    entitlements: 'Entitlements'
  },
  modal: {
    included: 'Enthalten',
    notIncluded: 'Nicht enthalten'
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie diese Entitlementgruppe wirklich löschen?'
  },
  alerts: {
    errorLoadingEntitlements: 'Die Entitlements konnten nicht geladen werden.',
    errorLoading: 'Die Entitlementgruppe konnten nicht geladen werden.',
    saveFailed: 'Die Entitlementgruppe konnte nicht gespeichert werden.',
    saveSuccess: 'Die Entitlementgruppe wurde erfolgreich gespeichert.',
    deleteFailed: 'Die Entitlementgruppe konnte nicht gelöscht werden.',
    deleteSuccess: 'Die Entitlementgruppe wurde erfolgreich gelöscht.'
  }
};

export default de;
export type AccessHandlerEntitlementGroupsTranslation = typeof de;
